import { createMuiTheme } from "@material-ui/core"

const theme = createMuiTheme({
  // palette: {
  //   type: "dark",
  // },
})

export default theme
